import { generateEnum } from '~/utils/enumUtil'
// 以下為使用方法說明
// export const Gender = generateEnum({
//   MALE: '男',
//   FEMALE: '女',
// });
// 等同於產生下面的類 enum 物件
// export const Gender = {
//   MALE: 'MALE',
//   FEMALE: 'FEMALE',
//   display(value) {
//     return {
//       MALE: '男',
//       FEMALE: '女',
//     }[value]
//   }
//   values() {
//     return [
//       'MALE', 'FEMALE'
//     ]
//   }
// }
/** 性別 */
export const Gender = generateEnum({
  MALE: '男',
  FEMALE: '女',
})
export const LawFirmCustomerType = generateEnum({
  NONE: '無',
  CLIENT: '委託人',
  OPPOSING_PARTY: '對造人',
})
export const LawFirmEmployeeType = generateEnum({
  NONE: '無',
  EMPLOYED_LAWYER: '受雇律師',
  PARTNER_LAWYER: '合夥律師',
  CO_LAWYER: '合署律師',
  LAWYER_ASSISTANT: '律師助理',
})
export const LawFirmCaseType = generateEnum({
  NONE: '無',
  LITIGATION: '訴訟',
  NON_LITIGATION: '非訟',
  PRE_LITIGATION: '訴訟前程序',
})
export const LawFirmCaseState = generateEnum({
  NONE: '無',
  UNCLOSED: '未結案',
  CLOSED: '已結案',
  JUDGED: '已判決',
})
export const LawFirmReceiptState = generateEnum({
  NONE: '無',
  ISSUED: '已開立',
  PRINTED: '已列印',
  CANCELLED: '已作廢',
})
export const LawFirmCaseLawyerRole = generateEnum({
  NONE: '無',
  MAIN_LAWYER: '主辦',
  ASSISTANT_LAWYER: '協辦',
  TERMINATED: '已終止',
})
